export const UserDetail = () => {
  return <>
    Passkey Server User Details
  </>
}